import type { FaireBrandEntity } from "../../entity_types/brand";

export const onboarding_offfaire_2: FaireBrandEntity = {
  token: "onboarding_offfaire_2",
  type: "brand",
  name: "Artisan Home",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/1666ef36b9499bd95f7080f86e21f06298ceb0ebc5e877c05a3d1426e9c7fc0f.webp",
  minimumOrderDollars: 100,
  rating: 4.6,
  location: "US",
  tags: ["onboarding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
